// Live-refresh for kickstart progress bars (Turbo/Hotwire is disabled here).
// Polls the JSON status endpoint and reloads the page when any visible
// kickstart's state/percent changed. Only runs on pages that render a
// .kickstart-progress bar (dashboard, system show).
import $ from "jquery"

$(function () {
  if ($(".kickstart-progress[data-system-id]").length === 0) return

  const STATUS_URL = "/page/kickstart_status"
  const INTERVAL = 10000
  let timer = null

  function schedule() {
    timer = setTimeout(poll, INTERVAL)
  }

  function poll() {
    $.getJSON(STATUS_URL)
      .done(function (rows) {
        const byId = {}
        rows.forEach(function (r) { byId[r.id] = r })

        let changed = false
        $(".kickstart-progress[data-system-id]").each(function () {
          const $el = $(this)
          const r = byId[$el.data("system-id")]
          if (!r) return // no longer active (e.g. expired) -> leave as rendered
          const cur = String($el.data("ks-state")) + ":" + String($el.data("ks-percent"))
          const next = String(r.status) + ":" + String(r.percent)
          if (cur !== next) changed = true
        })

        if (changed) {
          window.location.reload()
          return
        }
        schedule()
      })
      .fail(schedule)
  }

  schedule()
})
